/**
 * Vuex module for conferences.
 */
import API from '@/api'
import events from 'Store/events'
import debug from 'debug'
import Announcement from 'Store/class/announcements/announcement'
import VoiceType from 'Store/class/announcements/voice_type'

const dbg = debug('store:action:announce:')

const actions = {
  load: function ({ commit, rootGetters, state }, _data) {
    dbg('Init annoucements list')
    events.mask()
    const { start, perPage } = state.pagination
    return API.getAnnouncements(start, perPage, rootGetters['search/searchText']).then(({ data }) => {
      if (!data?.success) {
        dbg('Invalid data announcements data format: %o', data)
        throw new Error('Invalid data announcements data format')
      }
      commit('RESET')
      commit('SET_TOTAL', data.total)

      for (const item of data.data) {
        commit('ADD_ANNOUNCEMENT', item)
      }
    }).catch(err => {
      dbg(err)
      dbg(err?.response)
      events.pubError('Failed to load announcements')
    }).finally(() => {
      events.unmask()
    })
  },

  getTTSVoiceTypes: function ({ commit }) {
    dbg('Init TTS voice types')
    return API.getTTSVoiceTypes().then(({ data }) => {
      commit('RESET_VOICES')
      for (const item of data.data) {
        commit('ADD_VOICE', item)
      }
    }).catch(err => {
      dbg(err)
      dbg(err?.response)
      events.pubError('Failed to load TTS voice types')
    })
  },

  setPage: function ({ commit }, page) {
    commit('SET_PAGE', page)
  },

  setLimitPerPage: function ({ commit }, perPage) {
    commit('SET_LIMIT_PER_PAGE', perPage)
  },

  updateRec: function ({ commit }, { id, data }) {
    commit('UPDATE_RECORD', { id, data })
  }
}

const mutations = {
  RESET (state) {
    state.items = []
  },

  ADD_ANNOUNCEMENT (state, data) {
    state.items.push(new Announcement(data))
  },

  RESET_VOICES (state) {
    state.voiceTypes = []
  },

  ADD_VOICE (state, data) {
    state.voiceTypes.push(new VoiceType(data))
  },

  UPDATE_RECORD (state, { id, data }) {
    const rec = state.items.find(el => el.id === id)
    if (!rec) {
      dbg(`Announcement with ID '${id} is not found in store'`)
      return
    }
    rec.name = data.name
    rec.pin = data.pin
    rec.lang = data.dest_lang
  },

  SET_TOTAL (state, total) {
    state.pagination.total = total
    state.pagination.pages = Math.ceil(total / state.pagination.perPage)
  },

  SET_PAGE (state, page) {
    state.pagination.curPage = page
    state.pagination.start = (page - 1) * state.pagination.perPage
  },

  SET_LIMIT_PER_PAGE (state, perPage) {
    state.pagination.perPage = perPage
  }
}

const state = {
  items: [],
  voiceTypes: [],
  pagination: {
    total: 0,
    perPage: 18,
    curPage: 1,
    pages: 0,
    start: 0
  }
}

const getters = {
  items: state => state.items,
  voiceTypes: state => state.voiceTypes,
  pagination: state => state.pagination
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
